<template>
  <div class="cartItem notranslate cart-amenity-list-item"
    :class="{
      disabled: !item.isAvailable}">
    <p v-if="item.first" class="submitTo">{{locale.amenity}}</p>
    <div class="checkbox">
      <input type="checkbox"
        :id="item.cartId"
        :disabled="!item.isAvailable"
        v-model="item.isChecked"
        @change="checkedItem">
      <label :for="item.cartId"></label>
    </div>
    <div class="inner">
      <p v-if="!item.isAvailable" class="validateMessage notranslate" @click.stop="toggleTable(true)">{{locale.not_available}}<i>{{locale.available_time}}</i></p>
      <div class="itemInfo">
        <div class="subject">{{locale.amenity}}</div>
      </div>
    <div class="itemOption">
      <div class="amenityList">
        <div v-for="amenity in item.items"
          :key="amenity.item"
          class="amenityItem"
          :class="{disabled: isDisabled(amenity)}">
          <div class="icon">
            <router-link :to="{
              name: 'amenity',
              params: { ln: $route.params.ln }
            }">
            <img :src="require(`@/assets/img/amenity/${getItemCode(amenity.item)}.png`)" alt="" />
            </router-link>
          </div>
          <div class="name toCapitalize">
            {{getItemName(amenity)}}
            <span v-if="amenity.price" class="colorGrey">({{priceFormat(amenity.price)}})</span>
            * {{amenity.count}}
            <!-- <p v-if="amenity.disabled" class="changeMessage colorRed">{{locale.message_cart_amenity_disabled}}</p>
            <p v-if="amenity.countChanged" class="changeMessage colorGrey">{{locale.message_cart_amenity_changed_count}}</p>
            <p v-if="amenity.count <= 0" class="changeMessage colorGrey">요청 가능한 수량이 없습니다.</p>
            <p v-if="amenity.orderLimit && amenity.passedOrder !== true" class="changeMessage colorGrey">{{orderMaxMessage(amenity.item)}}</p> -->
          </div>
          <div class="count">
            <span v-if="isDisabled(amenity)" class="disabled">{{locale.amenity_pause}}</span>
            <span v-else-if="amenity.price">{{priceFormat(amenity.price * amenity.count)}}</span>
          </div>
          <p v-if="disabledMessage(amenity)" class="changeMessage colorGrey">{{disabledMessage(amenity)}}</p>
          <button type="button" class="btnDel" @click="deleteItem($event, amenity.item)">{{ locale.delete }}</button>
        </div>
      </div>
      <div v-if="!item.last && item.price &&
        item.price.info && item.price.info.total > 0 || item.changedInfo && item.changedInfo.total > 0" class="priceInfo">
        <div v-if="item.price.info && item.price.info.total > 0 || item.changedInfo && item.changedInfo.total > 0" class="item price">
          <div class="label">{{locale.total}}</div>
          <div class="value">
            <em>{{priceFormat(itemTotalPrice)}}</em>
          </div>
        </div>
      </div>
      <div v-if="item.last" class="multiCartItem">
        <div v-if="item.multiCartPrice" class="multi-cart-item-total">
          <div v-if="multiCartTax">
            <div class="total tax">
              <span class="label">소계</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.subtotal)}}</em>
              </span>
            </div>
            <div class="total tax">
              <span class="label">Tax({{multiCartTax.taxLabel}})</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.tax)}}</em>
              </span>
            </div>
            <div class="total">
              <span class="label">{{locale.total}}</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.total)}}</em>
              </span>
            </div>
          </div>
          <div v-else class="total">
            <span class="label">{{locale.total}}</span>
            <span class="value">
              <em>{{priceFormat(item.multiCartPrice)}}</em>
            </span>
          </div>
        </div>
        <div class="btns">
          <button type="button" 
            class="btn toCapitalize" :disabled="!multiCartAvailable || !item.isChecked" @click="requestMultiCart"
            :style="!(!multiCartAvailable || !item.isChecked) && {
              ...skinStyle('productBtncart', 'background-color'),
              ...skinStyle('productBtncart', 'border-color'),
            }"

          >
            <span>{{priceFormat(item.multiCartPrice)}} / </span> 
            {{multiCartAvailable ? locale.btn_request : requestDisabled.message}}
          </button>
        </div>
      </div>
      <div v-else-if="!multiCartAvailable" class="disabledMessage colorRed">{{requestDisabled.message}}</div>
    </div>
    </div>
    <AvailableTable
      v-if="!isAvailable && availableTable"
      :table="setting.available.set"
      :locale="locale"
      @close="toggleTable(false)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import AvailableTable from '@/components/Util/AvailableTable'

export default {
  name: 'CartItemAmenity',
  props: [
    'lang',
    'item',
    'change',
    'locale',
    'multiCartAvailable',
    'multiCartTax',
    'setting'
  ],
  components: {
    AvailableTable
  },
  computed: {
    ...mapGetters({
      pointColors: 'common/getPointColors',
    }),
    getAvailableDay () {
      return this.$store.getters['util/getAvailableDay']
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    localeAmenity () {
      return this.$store.state.system.localeAmenity.data
    },
    requestDisabled () {
      let message = this.locale.amenity_pause
      const limit = (this.setting && this.setting.itemLimitActive && this.setting.itemLimit) || null
      const items = this.item.items.filter(x => {
        return !x.disabled && x.orderLimit
          ? x.passedOrder && x.passedCount
          : x.count > 0
      }).length
      if (limit && limit < items) {
        message = this.locale.amenity_item_limit.replace('{var}', limit)
      }
      return {
        limit: limit,
        items: items,
        message: message
      }
    },
    itemTotalPrice () {
      return this.item.price
        ? this.item.price.info.tax ? this.item.price.info.subtotal : this.item.price.info.total
        : 0
    }
  },
  created () {
    // this.loadPage()
    this.checkAvailableTime()
  },
  data () {
    return {
      itemAvailable: {},
      isAvailable: true,
      availableTable: false
    }
  },
  methods: {

    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    checkAvailableTime () {
      let isAvailable = true
      const available = this.setting && this.setting.available // submit 데이터
      if (available) {
        const isAlways = available.state === '01' // 01 ? always : each
        const today = moment().isoWeekday() - 1
        const day = available.set[today]
        this.checkAvailable = setInterval(() => {
          const check = this.getAvailableDay(day)
          isAvailable = isAlways
            ? true
            : check
          this.isAvailable = isAvailable
          if (!isAvailable) {
            this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: false })
          }
        }, 1000)
      }
    },
    toggleTable (isOpen) {
      this.availableTable = isOpen
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    getItemName (item) {
      const itemCode = this.getItemCode(item.item)
      const itemName = `amenity_${itemCode}`
      const lang = this.$route.params.ln
      return item.label ? item.label[lang] : this.localeAmenity[itemName]
    },
    getItemCode (code) {
      return code.toLowerCase()
    },
    checkedItem (e) {
      const isChecked = e.target.checked
      this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: isChecked })
    },
    disabledMessage (amenity) {
      let message = null
      if (amenity.disabled) {
        message = this.locale.message_cart_amenity_disabled
      }
      if (amenity.countChanged) {
        message = this.locale.message_cart_amenity_changed_count
      }
      if (amenity.count <= 0) {
        message = this.locale.amenity_noitem_request
      }
      if (amenity.orderLimit && amenity.passedOrder !== true) {
        message = this.orderMaxMessage(amenity.item)
      }
      return message
    },
    isDisabled (amenity) {
      return amenity.disabled || (amenity.orderLimit && amenity.passedOrder !== true) || amenity.count <= 0
    },
    orderMaxMessage (raCode) {
      const item = this.item.items.find(x => x.item === raCode)
      const orderMax = item ? item.orderMax : null
      return orderMax
        ? this.item.orderLimit === 'day'
          ? this.locale.amenity_order_max_day.replace('{var}', item.orderMax)
          : this.locale.amenity_order_max_ota.replace('{var}', item.orderMax)
        : null
    },
    deleteItem (e, raCode) {
      e.stopPropagation()
      this.$emit('deleteAmenity', raCode)
    },
    requestMultiCart (e) {
      e.stopPropagation()
      this.$emit('requestMultiCart', this.item.submitId)
    }
  }
}
</script>

<style lang="scss" scoped>
.cartItem .inner {
  display: block;
  .priceInfo {
    margin-left: -45px;
    margin-right: -15px;
    padding: 15px 15px 15px 45px;
  }
}
.cartItem:not(.noData).first .amenityItem .btnDel {
  top: 0;
}
.amenityList {
  margin-top: 8px;
  border-radius: 4px;
  background-color: $bg-default;
  .amenityItem {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    padding: 12px 30px 12px 8px;
    .icon {
      flex: none;
      width: 24px;
    }
    .name {
      margin-left: 8px;
      margin-right: 8px;
    }
    .count {
      margin-left: auto;
      .disabled {
        font-size: 0.8em;
        color: $color-red;
        white-space: nowrap;
      }
    }
    & + .amenityItem {
      border-top: 1px dashed $color-lgrey2;
    }
    &.disabled {
      color: $color-lgrey;
      img {
        opacity: 0.4;
      }
      .count {
        width: calc(100% - 40px);
        margin-left: 40px;
      }
    }
  }
}
.changeMessage {
  width: 100%;
  padding-left: 40px;
  font-size: 0.85em;
}
.disabledMessage {
  margin-left: -30px;
  margin-bottom: 15px;
  padding: 10px;
  text-align: center;
  color: $color-white;
  border-radius: 4px;
  background-color: rgba($color-red, 0.75);
}
@media screen and (min-width: 768px) {
  .amenityList {
    margin-left: -30px;
    margin-right: 0;
    .amenityItem {
      margin-left: 0;
      margin-right: 0;
      padding-left: 30px;
    }
  }
}
.validateMessage {
  display: inline-block;
  position: relative;
  margin-bottom: 8px;
  padding: 5px 8px;
  text-align: center;
  vertical-align: top;
  white-space: nowrap;
  color: $color-white;
  border-radius: 4px;
  background-color: $color-red;
  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 28px;
    width: 6px;
    height: 6px;
    margin-top: -3px;
    background-color: $color-red;
    transform: rotate(45deg);
  }
  i {
    display: inline-block;
    position: relative;
    margin-left: 5px;
    padding: 0 4px;
    font-size: 10px;
    font-style: normal;
    color: $color-red;
    border-radius: 4px;
    background-color: $color-white;
  }
}
@media screen and (min-width: 768px) {
  .validateMessage {
    width: 100%;
    margin-bottom: 5px;
    border-radius: 20px;
    &:before {
      display: none;
    }
  }
}

.cart-amenity-list-item .inner .multiCartItem .btns button span{
  display: none;
}
</style>
